import { Component, Input, Output, EventEmitter } from '@angular/core'
import { Store } from '@ngrx/store'
import { State } from '../../../store/app.model'
import { StorageService } from '../../../services'
import { OssConfig } from '../../../config/oss.config'
import { StorageBucket } from '../../../models'

@Component({
  selector: 'app-multi-file-upload-com',
  templateUrl: './multi-file-upload.com.html'
})

export class MultiFileUploadComponent {

  @Input() bucket: StorageBucket
  @Output() event = new EventEmitter<any>()
  model = {
    files: [],
    config: OssConfig,
    uploaded: { files: [], urls: [], file_names: [] }
  }

  constructor(private storage: StorageService, private store: Store<State>) {}

  public onFileInputChange(event) {
    const files = Array.from(event.srcElement.files)
    this.model.files = this.model.files.concat(files)
  }

  public deleteFile(i) {
    this.model.files.splice(i, 1)
  }

  public uploadAllFiles() {
    if (this.model.files.length) {
      this.uploadFiles(this.model.files)
    }
  }

  public downloadFile(i) {
    const result = this.storage.downloadOneFile(
      this.bucket,
      this.model.uploaded.file_names[i]
    )
    window.location.href = result
  }

  private uploadFiles(files) {
    const file_names = files.map(f => this.storage.timeStampedFileName(f.name))
    const pros = files.map((f, i) => this.storage.uploadOneFile(this.bucket, f, file_names[i]))
    this.store.dispatch({ type: 'loading', payload: { loading: true } })
    Promise.all(pros).then(results => {
      this.store.dispatch({ type: 'loading', payload: { loading: false } })
      const uploads = files.map((f, i) => {
        return {
          url: this.bucket.get_url(file_names[i]),
          name: file_names[i]
        }
      })
      this.model.uploaded.urls = this.model.uploaded.urls.concat(uploads.map(u => {
        return u.url
      }))
      this.model.uploaded.file_names = file_names
      this.model.uploaded.files = this.model.uploaded.files.concat(this.model.files)
      this.model.files = []
      this.event.emit({
        source: 'multi-file-upload-com',
        success: true,
        file_names: file_names
      })
    }).catch(error => {
      this.store.dispatch({ type: 'loading', payload: { loading: false } })
      this.event.emit({
        source: 'multi-file-upload-com',
        success: false,
        file_names: null
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/multi-file-upload/multi-file-upload.com.ts